import React from 'react';
import SafeIcon from './common/SafeIcon';
import { FiSearch, FiBell, FiChevronDown } from 'react-icons/fi';

export default function TopBar() {
  return (
    <div className="h-16 w-full bg-navy-800 border-b border-navy-700 flex items-center justify-between px-6 z-20 sticky top-0">
      <div className="flex-1 max-w-xl hidden md:flex items-center">
        <div className="relative w-full">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input 
            type="text" 
            placeholder="Search tickets, customers, articles... (Press '/')" 
            className="w-full bg-navy-900/50 border border-navy-600 rounded-lg py-2 pl-10 pr-4 text-sm text-slate-200 placeholder-slate-500 focus:outline-none focus:border-cyan-neon focus:ring-1 focus:ring-cyan-neon transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-4 ml-auto">
        <button className="relative p-2 text-slate-400 hover:text-white transition-colors">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-priority-red rounded-full"></span>
        </button>
        
        <div className="h-8 w-px bg-navy-600 mx-2"></div>
        
        <button className="flex items-center gap-2 hover:bg-navy-700 p-1.5 rounded-lg transition-colors">
          <div className="w-8 h-8 rounded bg-gradient-to-tr from-cyan-600 to-blue-500 flex items-center justify-center text-white font-bold text-sm shadow-lg">
            A4
          </div>
          <SafeIcon icon={FiChevronDown} className="text-slate-400" />
        </button>
      </div>
    </div>
  );
}